import SubTareaService from 'src/modules/subTarea/subTareaService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'SUBTAREA_VIEW';

const subTareaViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: subTareaViewActions.FIND_STARTED,
      });

      const record = await SubTareaService.find(id);

      dispatch({
        type: subTareaViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: subTareaViewActions.FIND_ERROR,
      });

      getHistory().push('/sub-tarea');
    }
  },
};

export default subTareaViewActions;
